import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

const ReminderBlock = ({
  reviewers,
  remindInProgressIds,
  handleRemindClick,
  formatSharedDate,
  isModal,
}) => {
  return (
    <>
      {reviewers?.map((reviewData) => (
        <Box
          key={reviewData?.id}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Typography
            sx={{
              fontFamily: "manrope",
              fontSize: "13px",
              fontWeight: 500,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: isModal ? "300px" : "150px",
            }}
          >
            {reviewData?.shared_with?.full_name ||
              reviewData?.shared_with?.username}
          </Typography>

          {reviewData?.status === "APPROVED" ? (
            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: 500,
                fontFamily: "manrope",
                color: "#98A6BA",
              }}
            >
              Review Approved
            </Typography>
          ) : (
            <Typography
              sx={{
                fontSize: "13px",
                fontFamily: "manrope",
                color: "#48566B",
              }}
            >
              Sent on{" "}
              {reviewData?.shared_at
                ? formatSharedDate(reviewData.shared_at)
                : ""}
              .{" "}
              <Box
                component="span"
                sx={{
                  fontWeight: reviewData?.can_remind ? "600" : "500",
                  color: reviewData?.can_remind ? "#0C53BB" : "#95B5E3",
                  cursor:
                    reviewData?.can_remind &&
                    !remindInProgressIds.includes(reviewData?.id)
                      ? "pointer"
                      : "not-allowed",
                  pointerEvents:
                    reviewData?.can_remind &&
                    !remindInProgressIds.includes(reviewData?.id)
                      ? "auto"
                      : "none",
                }}
                onClick={() => {
                  if (
                    reviewData?.can_remind &&
                    !remindInProgressIds.includes(reviewData?.id)
                  ) {
                    handleRemindClick(reviewData, isModal);
                  }
                }}
              >
                Remind
              </Box>
            </Typography>
          )}
        </Box>
      ))}
    </>
  );
};

ReminderBlock.propTypes = {
  reviewers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      shared_with: PropTypes.shape({
        full_name: PropTypes.string,
        username: PropTypes.string,
      }).isRequired,
      shared_at: PropTypes.string,
      can_remind: PropTypes.bool.isRequired,
    })
  ).isRequired,
  remindInProgressIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleRemindClick: PropTypes.func.isRequired,
  formatSharedDate: PropTypes.func.isRequired,
  isModal: PropTypes.bool,
};

export default ReminderBlock;
